import { Dispatch } from 'react';
import { SuSyApi } from '../../api/susyApi';
import { GradingAction, GradingActionTypes } from '../actionTypes/grading';
import {
    CriteriaScoringCards,
    CriteriaNonScoringCards,
    IDocument,
    User,
} from '../types';
import { GradingSaveType } from 'susy-common/enums';

export const getGrading =
    (projectId: string | null) => async (dispatch: Dispatch<GradingAction>) => {
        const response = await SuSyApi.get(`/grading/${projectId}`);
        dispatch({
            type: GradingActionTypes.GET_GRADING,
            payload: response.data,
        });
    };

export const saveScoringGrading =
    (
        grading: CriteriaScoringCards,
        projectId: string | null,
        rubricId: string | undefined,
        directlyEnteredTotalPoints: number | null,
        areCustomMaxPointsEnteredForCriteria: boolean | null,
        remark: string,
        saveType: GradingSaveType,
        files: File[],
        existingRemainingFiles: IDocument[],
        selectedStudent: User | null
    ) =>
    async (dispatch: Dispatch<GradingAction>) => {
        const gradingArray = Object.values(grading);
        const criterias = gradingArray.map((gr) => {
            return {
                criteriaId: gr._id,
                points: gr.points,
                comment: gr.comment,
                maxPointsBySupervisor: gr.maxPointsBySupervisor,
            };
        });
        const formData = new FormData();

        for (const file of files) {
            formData.append('gradingFiles', file);
        }

        formData.append(
            'gradingData',
            JSON.stringify({
                grading: {
                    criterias,
                    remark,
                    existingRemainingFiles,
                    directlyEnteredTotalPoints,
                    areCustomMaxPointsEnteredForCriteria,
                },
                projectId,
                rubricId,
                selectedStudentId: selectedStudent?._id,
            })
        );

        const response = await SuSyApi.patch(
            getSaveGradingURL(saveType),
            formData
        );

        dispatch({
            type: GradingActionTypes.SAVE_GRADING,
            payload: response.data,
        });
    };

export const saveScoringGradingAndCompleteAdditionalSupervisor =
    (
        grading: CriteriaScoringCards,
        projectId: string | null,
        rubricId: string | undefined,
        directlyEnteredTotalPoints: number | null,
        areCustomMaxPointsEnteredForCriteria: boolean | null,
        remark: string,
        saveType: GradingSaveType,
        files: File[],
        existingRemainingFiles: IDocument[],
        selectedStudent: User | null
    ) =>
    async (dispatch: Dispatch<GradingAction>) => {
        const gradingArray = Object.values(grading);
        const criterias = gradingArray.map((gr) => {
            return {
                criteriaId: gr._id,
                points: gr.points,
                comment: gr.comment,
                maxPointsBySupervisor: gr.maxPointsBySupervisor,
            };
        });
        const formData = new FormData();

        for (const file of files) {
            formData.append('gradingFiles', file);
        }

        formData.append(
            'gradingData',
            JSON.stringify({
                grading: {
                    criterias,
                    remark,
                    existingRemainingFiles,
                    directlyEnteredTotalPoints,
                    areCustomMaxPointsEnteredForCriteria,
                },
                projectId,
                rubricId,
                selectedStudentId: selectedStudent?._id,
            })
        );

        const response = await SuSyApi.patch(
            '/grading/submitAsAdditionalSupervisor',
            formData
        );

        dispatch({
            type: GradingActionTypes.SAVE_GRADING,
            payload: response.data,
        });
    };

const getSaveGradingURL = (saveType: GradingSaveType) => {
    switch (saveType) {
        case GradingSaveType.DRAFT:
            return '/grading';
        case GradingSaveType.COMPLETE:
            return '/grading/submit';
        case GradingSaveType.COMPLETE_AS_SHARED:
            return '/grading/submitAsShared';
    }
};

export const saveNonScoringGrading =
    (
        grading: CriteriaNonScoringCards,
        projectId: string | null,
        rubricId: string | undefined,
        remark: string,
        submit: boolean,
        selectedStudent: User | null
    ) =>
    async (dispatch: Dispatch<GradingAction>) => {
        const gradingArray = Object.values(grading);
        const criterias = gradingArray.map((gr) => {
            return {
                criteriaId: gr._id,
                criteriaLevelId: gr.selectedCriteriaLevelId,
                comment: gr.comment,
            };
        });
        const formData = new FormData();
        let response;

        formData.append(
            'gradingData',
            JSON.stringify({
                grading: { criterias, remark },
                projectId,
                rubricId,
                selectedStudentId: selectedStudent?._id,
            })
        );

        if (submit) {
            response = await SuSyApi.patch(`/grading/submit`, formData);
        } else {
            response = await SuSyApi.patch(`/grading`, formData);
        }

        dispatch({
            type: GradingActionTypes.SAVE_GRADING,
            payload: response.data,
        });
    };
